import { render } from "./AdminCursos.vue?vue&type=template&id=5cdbb5ec"
import script from "./AdminCursos.vue?vue&type=script&lang=js"
export * from "./AdminCursos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__